import { render, staticRenderFns } from "./HistoryItemProlongation.vue?vue&type=template&id=0e51b4b4"
import script from "./HistoryItemProlongation.vue?vue&type=script&lang=js"
export * from "./HistoryItemProlongation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports